<template>
  <div class="b-card-container">
    <div class="bc-header-container">
      <div class="bc-header">Thermostat Detail</div>
      <div class="bc-header">Total: {{ tZones.length }}</div>
    </div>
    <div class="bc-table-container">
      <div class="bct-header-container">
        <div class="bct-header">Location/Zone name</div>
        <div class="bct-header">Thermostat Type</div>
        <div class="bct-header">Brand</div>
        <div class="bct-header">Smart Thermostat Connected</div>
      </div>
      <div class="bct-body-container">
        <div v-for="s in tZones" :key="s.id" class="bct-row-container">
          <div class="bct-body">
            {{ s.zone }}
          </div>
          <div class="bct-body">
            {{ s.thermostatType || '--' }}
          </div>
          <div class="bct-body">
            {{ s.thermostatBrand || '--' }}
          </div>
          <div class="bct-body">
            {{ s.thermostatId ? 'Yes' : 'No' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'ThermostatDetail',
  mixins: [customerDetailMixin],
};
</script>

